import { create } from "@storybook/theming";
import { theme } from "../src/theme";

export default create({
  base: "light",
  brandTitle: "Figmayo UI",
  brandTarget: "_self",
  // Typography
  fontBase: theme.fonts.body,
  fontCode: "Inter"
});
